export default __webpack_public_path__ + "static/media/BAIGNADE SURVEILLÉE.96f2d955.svg";